export default "__VITE_ASSET__26fa4a1b__"